import { GestureDoubleTapIcon } from './GestureDoubleTapIcon';

/**
 * author: Michael Richins
 * id D02C7FA0-E8E6-48B7-BEB7-4678B8D9DCA1
 * name gesture-double-tap
 * version: 1.9.32
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/gesture-double-tap.svg
 * tags
 */
export const InteractionDoubleTapIcon = GestureDoubleTapIcon;
export default InteractionDoubleTapIcon